<template>
  <div
    :class="{ active : flashcardStatusFilter.id == status.id }"
    class="filter-tab-component-container"
  >
    <div
      :class="`content ${status.name || 'all'}`"
      @click="changeFilter(status)"
    >
      <span>{{ status.displayName || 'All' }}</span>
      <div class="counter">
        {{ count }}
      </div>
    </div>
    <div class="spacer" />
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Object,
      default: () => {},
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    flashcardStatusFilter() {
      return this.$store.getters['flashcardStatuses/flashcardStatusFilter'];
    },
  },
  methods: {
    changeFilter(status) {
      this.$store.commit('flashcardStatuses/setFlashcardStatusFilter', status.id);
      this.$analytics.events.selectedFilter(status.displayName);
    },
  },
};
</script>

<style lang='scss' scoped>
  .filter-tab-component-container {
    margin-bottom: -1px;
    margin-right: rem-calc(3);

    &.active {

      .spacer {
        border-top: 0;
      }

      .content {
        background: white;
        border: none;
        padding: rem-calc(16);

        &:hover {
          background-color: white;
          background-image: none;
        }
      }
    }

    &:not(.active) .counter {
      @include breakpoint(small) {
        background: transparent !important;
      }
    }

    .content {
      align-items: center;
      background-image: linear-gradient(to top, #f2f4f7, #ffffff);
      /*border: 1px solid #dfe3e9;*/
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom: 0;
      box-shadow: 0 1px 2px 0 rgba(0,0,0,0.25);
      color: #354052;
      cursor: pointer;
      display: flex;
      font-size: rem-calc(12);
      font-weight: $semi-bold;
      justify-content: center;
      min-width: rem-calc(30);
      padding: rem-calc(12) rem-calc(16);

      &:hover {
        background-image: linear-gradient(to top, #E4E7EB, #ffffff);
      }

      .counter {
        background-color: #f1f4f8;
        color: #354052;
        font-size: rem-calc(10);
        margin-left: 8px;
        padding: rem-calc(4) rem-calc(8);

        // @include breakpoint(small) {
        //   padding: 0;
        // }
      }

      .counter, span {
        @include breakpoint(small) {
          font-size: rem-calc(12);
        }
      }

      &.green {
        @include breakpoint(small) {
          background: #7bd56e;
          // border-color: #63B757;

          + .spacer {
            // background: #7bd56e;
            // border-color: #63B757;
          }
        }

        .counter {
          background-color: #7bd56e;
          color: white;
        }
      }

      &.yellow {
        @include breakpoint(small) {
          background: #ffd27c;
          // border-color: #E1B364;

          + .spacer {
            // background: #ffd27c;
            // border-color: #E1B364;
          }
        }

        .counter {
          background-color: #ffd27c;
          color: white;
        }
      }

      &.red {
        @include breakpoint(small) {
          background: #fb7e7a;
          // border-color: #DD6562;

          + .spacer {
            // background: #fb7e7a;
            // border-color: #DD6562;
          }
        }

        .counter {
          background-color: #fb7e7a;
          color: white;
        }
      }

      &.bookmarked {
        @include breakpoint(small) {
          background: #4fb9de;
          // border-color: #3592B8;

          + .spacer {
            // background: #4fb9de;
            // border-color: #3592B8;
          }
        }

        .counter {
          background-color: #4fb9de;
          color: white;
        }
      }

      &.all {
        @include breakpoint(small) {
          background: white;
          border-color: #dfe3e9;

          + .spacer {
            background: white;
            border-color: #dfe3e9;
          }

          .counter {
            display: none;
          }
        }
      }

      &:not(.all) {
        @include breakpoint(small) {
          span {
            display: none;
          }

          .counter {
            margin: 0;
          }
        }
      }
    }

    .spacer {
      background-color: white;
      border: 1px solid #dfe3e9;
      border-bottom: 0;
      box-sizing: border-box;
      flex: 1;
      height: 1px;

      @include breakpoint(small) {
        height: 1px;
      }
    }

    &.active {
      z-index: 100;
    }
  }
</style>
